import './login.component.less'

class LoginRedirectController {
  constructor ($log, $state, AuthService) {
    'ngInject'

    this._$log = $log
    this._$state = $state
    this._AuthService = AuthService
  }

  $onInit () {
    this.working = true
    this.error = ''

    this._AuthService.handleRedirect()
      .then(result => {
        if (result) {
          return null
        }

        return this._AuthService.ensureAuthenticated()
          .then(isAuthed => {
            if (!isAuthed) {
              this._$state.go('login')
            }
          })
      })
      .catch(error => {
        this._$log.error('loginRedirectController: Error during redirect handling', error)
        this.error = error && error.message ? error.message : 'Sign-in failed.'
      })
      .finally(() => {
        this.working = false
      })
  }
}

export default {
  controller: LoginRedirectController,
  template: require('./login-redirect.component.html').default
}
